<template>
<w-sliding-popup title="쿼리수행기" ref="realtimeControlSlidingPopup" :default-content="false" @close="close">
  <div slot="content" class="body-content-no-scroll" style="height:100%;padding-bottom:0px !important;">
    <el-steps :active="active" finish-status="success">
      <el-step title="쿼리 입력"></el-step>
      <el-step title="수행결과 확인"></el-step>
    </el-steps>

    <div v-if="active === 1" style="height:calc(100% - 112px);">
      <div class="title-bar vertical-center-box">
        <div class="title-h4 mr-r10">쿼리 입력창</div>
        <span class="info-text" style="font-size:13px;">저장쿼리문 입력 및 수동 입력 모두 가능합니다. 또한 쿼리 작성 시 세미콜론(;)은 생략해 주십시오.</span>
      </div>
      <el-input class="mr-b25" type="textarea" :rows="10" v-model="queryTextarea" />
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="title-h4">저장 쿼리문</div>
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </el-row>
      <el-row style="height:calc(100% - 319px);">
        <el-table-wrapper key="queryTable" style="height:100%" :fit-height="true" height="230" :data="queryTableDatas" :columns="columns" :column-default="columnDefault" :total="total" remote :show-custom-header="true" :show-search-tool="showSearchTool" :pagination="true"
          @condition-change="queryListLoadStore" ref="queryTable">
          <span slot="queryContent-Slot" slot-scope="scope" class="link" @click="onClickSetQueryTextarea(scope.row)">{{scope.row.queryContents}}</span>
        </el-table-wrapper>
      </el-row>
    </div>

    <div v-else-if="active === 2" style="height:calc(100% - 112px);">
      <div class="title-h4 title-bar">
        적용쿼리문
      </div>
      <el-input class="mr-b25" type="textarea" :rows="10" readonly v-model="queryTextarea" />
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="title-h4">수행결과</div>
        <w-header-search-button @click="resultShowSearchTool = !resultShowSearchTool"></w-header-search-button>
      </el-row>
      <el-row v-loading="isLoading" style="height:calc(100% - 313px);">
        <el-table-wrapper key="resultTable" v-if="showResultTable" style="height:100%;" :fit-height="true" :data="resultTableDatas" :columns="resultColumns" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="resultShowSearchTool" :pagination="true">
          <span slot="queryContent-Slot" slot-scope="scope" class="link" @click="onClickSetQueryTextarea(scope.row)">{{scope.row.queryContents}}</span>
        </el-table-wrapper>
      </el-row>
    </div>
  </div>

  <div slot="footer">
    <el-row type="flex" justify="space-between">
      <div>
        <el-button v-if="active === 2" size="large" @click="onPrevButtonClick"><i class="fal fa-arrow-left mr-r2" />이전</el-button>
      </div>
      <div>
        <el-button v-if="active === 1" size="large" type="solid" class="mr-r4" @click="onClickExecuteUserQuery" :disabled="isQueryExecuteButtonFlag">쿼리 수행</el-button>
        <el-button v-if="active === 1" size="large" @click="$refs.realtimeControlSlidingPopup.close()">취소</el-button>
        <el-button v-if="active === 2" size="large" @click="$refs.realtimeControlSlidingPopup.close()">확인</el-button>
      </div>
    </el-row>
  </div>
</w-sliding-popup>
</template>

<script>
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import { mapGetters } from 'vuex';
import msgUtil from '@/utils/message';
import databaseInfoAPI from '@/api/performance/database/database-info';
import objtypeApi from '@/api/model/objtype';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import forEach from 'lodash/forEach';
import isUndefined from 'lodash/isUndefined';
import keys from 'lodash/keys';
import cloneDeep from 'lodash/cloneDeep';

const rsctypeIdFilterMap = {
  ORACLE: {
    value: 'OR_USER_QUERY',
    text: 'Oracle 사용자 쿼리',
  },
  MSSQL: {
    value: 'MS_USER_QUERY',
    text: 'MSSQL 사용자 쿼리',
  },
  MYSQL: {
    value: 'MY_USER_QUERY',
    text: 'MySql 사용자 쿼리',
  },
  TIBERO: {
    value: 'TB_USER_QUERY',
    text: 'Tibero 사용자 쿼리',
  },
  SYBASE: {
    value: 'SY_USER_QUERY',
    text: 'Sybase 사용자 쿼리',
  },
  SYBASEIQ: {
    value: 'IQ_USER_QUERY',
    text: 'Sybase IQ 사용자 쿼리',
  },
  INFORMIX: {
    value: 'IN_USER_QUERY',
    text: 'Informix 사용자 쿼리',
  },
  ALTIBASE: {
    value: 'AT_USER_QUERY',
    text: 'Altibase 사용자 쿼리',
  },
  DB2: {
    value: 'DB2_USER_QUERY',
    text: 'DB2 사용자 쿼리',
  },
  POSTGRESQL: {
    value: 'PG_USER_QUERY',
    text: 'PostgreSQL 사용자 쿼리',
  },
  CUBRID: {
    value: 'CU_USER_QUERY',
    text: 'Cubrid 사용자 쿼리',
  },
};

export default {
  name: 'WDatabaseQueryExecutorPopup',
  props: {
    objId: {
      type: Object,
    },
    objInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isLoading: false,
      active: 1,
      showSearchTool: false,
      columnDefault,
      total: null,
      queryTableDatas: [],
      queryTextarea: '',
      queryColumns: [
        {
          prop: 'rsctypeId',
          label: 'DB종류',
          sortable: true,
          filterMultiple: false,
          filters: [],
          remoteProp: 'rsctype_id',
          formatter: this.rsctypeIdFormatter,
        },
        {
          prop: 'rscId',
          label: '쿼리ID',
          sortable: true,
          searchable: true,
          remoteProp: 'rsc_id',
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'rscName',
          label: '쿼리설명',
          sortable: true,
          searchable: true,
          remoteProp: 'rsc_name',
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'queryContents',
          label: '수행쿼리문',
          sortable: true,
          searchable: true,
          remoteProp: 'query_contents',
          scopedSlot: 'queryContent-Slot',
        },
      ],
      columns: [],
      resultShowSearchTool: false,
      resultColumns: [],
      resultTableDatas: [],
      showResultTable: false,
    };
  },
  computed: {
    /**
     * [isQueryExecuteButtonFlag 쿼리수행 버튼 활성화]
     * @author {Yang}
     * @return {Boolean} [description]
     */
    isQueryExecuteButtonFlag() {
      return isUndefined(this.queryTextarea) ? true : isEmpty(this.queryTextarea);
    },
    ...mapGetters(['selectedNode']),
  },
  created() {
    const me = this;
    objtypeApi
      .getProviedObjtypeList('DBMS')
      .then((response) => {
        if (response.data.success && !isEmpty(response.data.data)) {
          const filters = [];
          forEach(response.data.data, (item) => {
            if (!isNil(rsctypeIdFilterMap[item.objtypeId])) {
              filters.push(rsctypeIdFilterMap[item.objtypeId]);
            }
            const columns = cloneDeep(me.queryColumns);
            const index = columns.findIndex((column) => column.prop === 'rsctypeId');
            columns[index].filters = filters;
            me.columns = columns;
          });
        } else {
          me.columns = me.queryColumns;
        }
      })
      .catch(() => {
        me.columns = me.queryColumns;
      });
  },
  methods: {
    /**
     * [open 열기 이벤트]
     * @author {Yang}
     * @return {[type]} [description]
     */
    open() {
      this.showResultTable = false;
      this.resultTableDatas = [];
      this.resultColumns = [];
      this.$refs.realtimeControlSlidingPopup.open();
      this.$nextTick(() => {
        this.queryListLoadStore();
      });
    },
    /**
     * [close 닫기 이벤트]
     * @author {Yang}
     * @return {[type]} [description]
     */
    close() {
      this.active = 1;
      this.showSearchTool = false;
      this.queryTableDatas = [];
      this.queryTextarea = '';
      // this.$emit('close');
      // this.$refs.realtimeControlSlidingPopup.close();
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * [rsctypeIdFormatter DB종류 포멧]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    rsctypeIdFormatter(row) {
      switch (row.rsctypeId) {
        case 'OR_USER_QUERY':
          return 'Oracle 사용자 쿼리';
        case 'MS_USER_QUERY':
          return 'MSSQL 사용자 쿼리';
        case 'MY_USER_QUERY':
          return 'MySql 사용자 쿼리';
        case 'TB_USER_QUERY':
          return 'Tibero 사용자 쿼리';
        case 'SY_USER_QUERY':
          return 'Sybase 사용자 쿼리';
        case 'IQ_USER_QUERY':
          return 'Sybase IQ 사용자 쿼리';
        case 'IN_USER_QUERY':
          return 'Informix 사용자 쿼리';
        case 'AT_USER_QUERY':
          return 'Altibase 사용자 쿼리';
        case 'DB2_USER_QUERY':
          return 'DB2 사용자 쿼리';
        case 'PG_USER_QUERY':
          return 'PostgreSQL 사용자 쿼리';
        case 'CU_USER_QUERY':
          return 'Cubrid 사용자 쿼리';
        default:
          return EMPTY_TEXT;
      }
    },
    /**
     * [onClickSetQueryTextarea 수행쿼리문 클릭시 쿼리 입력창에 입력]
     * @author {Yang}
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    onClickSetQueryTextarea(row) {
      this.queryTextarea = row.queryContents;
    },
    /**
     * [queryListLoadStore 저장쿼리문 데이터 로드]
     * @author {Yang}
     * @return {[type]} [description]
     */
    queryListLoadStore() {
      const tableParams = this.$refs.queryTable.getParameter();
      let objtypeId = '';
      if (!isNil(this.selectedNode.obj)) {
        objtypeId = this.selectedNode.obj.objtypeId;
      } else {
        objtypeId = this.objInfo.obj.objtypeId;
      }
      databaseInfoAPI
        .getDatabaseQueryInfo({
          objtypeId,
          ...tableParams,
        })
        .then((result) => {
          if (result.data.success === true) {
            this.queryTableDatas = result.data.data;
          }
        });
    },
    onPrevButtonClick() {
      this.active = 1;
    },
    /**
     * [onClickExecuteUserQuery 쿼리문 수행 및 결과 출력]
     * @author {Yang}
     * @return {[type]} [description]
     */
    onClickExecuteUserQuery() {
      let objId = null;
      if (!isNil(this.selectedNode.obj)) {
        objId = this.selectedNode.obj.objId;
      } else {
        objId = this.objInfo.obj.objId;
      }
      const params = {
        objId,
        query: this.queryTextarea,
      };
      this.active = 2;
      this.isLoading = true;
      const target = '쿼리';
      const action = '수행';
      databaseInfoAPI
        .executeDatabaseUserQuery(params)
        .then((result) => {
          if (result.data.success === true) {
            this.showResultTable = true; // 헤더가 없는 테이블을 표현하지 않기 위함
            const resultRow = result.data.data.resultSet;
            if (!isNil(resultRow)) {
              const tempKey = keys(resultRow[0]);
              const tempCol = [];
              forEach(tempKey, (key) => {
                tempCol.push({
                  prop: key,
                  label: key,
                  sortable: true,
                  searchable: true,
                  formatter: this.getTableValueAfterCheckEmpty,
                });
              });
              this.resultColumns = tempCol;
              this.resultTableDatas = resultRow;
            } else {
              this.$message(msgUtil.getCustomMsgData('쿼리 수행 결과가 없습니다.'));
            }
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/DatabaseQueryExecutorPopup.vue